module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "increment"
  }, [_c('div', {
    staticClass: "title-con"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("喜马拉雅用户数据：")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.initLoading),
      expression: "initLoading"
    }],
    attrs: {
      "placeholder": "请选择城市"
    },
    on: {
      "change": _vm.switchCity
    },
    model: {
      value: (_vm.curCityId),
      callback: function($$v) {
        _vm.curCityId = $$v
      },
      expression: "curCityId"
    }
  }, _vm._l((_vm.basicData), function(item) {
    return _c('el-option', {
      key: item.cityId,
      attrs: {
        "label": item.cityName,
        "value": item.cityId
      }
    })
  }))], 1), _vm._v(" "), (_vm.dataMsg) ? _c('p', {
    staticClass: "dataMsg"
  }, [_vm._v(_vm._s(_vm.dataMsg))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.basicData), function(itemCity) {
    return (itemCity.cityId === _vm.curCityId) ? _c('div', {
      staticClass: "dashboard"
    }, [_c('div', {
      staticClass: "nums-board"
    }, [_vm._m(0, true), _vm._v(" "), _c('ul', {
      staticClass: "board-content"
    }, _vm._l((_vm.numsKey), function(keyItem) {
      return _c('li', {
        staticClass: "board-content-item"
      }, [_c('div', {
        staticClass: "count-nums"
      }, [_c('span', [_vm._v(_vm._s(itemCity[((keyItem.key) + "Count")]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(keyItem.name))])]), _vm._v(" "), _c('ul', {
        staticClass: "percents"
      }, _vm._l((keyItem.dateType), function(typeItem) {
        return _c('li', {
          staticClass: "percent-item"
        }, [_c('span', {
          staticClass: "typeItem"
        }, [_vm._v(_vm._s(typeItem.name)), (typeItem.name == '周') ? _c('span', {
          staticClass: "oHelp forType"
        }, [_vm._v("?")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "dataBlock"
        }, [(itemCity[((keyItem.key) + "Compare" + (typeItem.key))].indexOf('-') === -1) ? _c('span', {
          staticClass: "up"
        }, [_vm._v("▲")]) : (itemCity[((keyItem.key) + "Compare" + (typeItem.key))] !== '0%') ? _c('span', {
          staticClass: "down"
        }, [_vm._v("▼")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(itemCity[((keyItem.key) + "Compare" + (typeItem.key))]))])])])
      }))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "charts-board"
    }, [_c('el-row', {
      staticClass: "row-bg",
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 7
      }
    }, [_c('el-radio-group', {
      attrs: {
        "fill": "#f86442"
      },
      on: {
        "change": _vm.switchChart
      },
      model: {
        value: (_vm.curChart),
        callback: function($$v) {
          _vm.curChart = $$v
        },
        expression: "curChart"
      }
    }, [_c('el-radio-button', {
      attrs: {
        "label": "active"
      }
    }, [_vm._v("活跃用户数")]), _vm._v(" "), _c('el-radio-button', {
      attrs: {
        "label": "newUser"
      }
    }, [_vm._v("新增用户数")])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-radio-group', {
      on: {
        "change": _vm.switchChartRegion
      },
      model: {
        value: (_vm.curChartRegion),
        callback: function($$v) {
          _vm.curChartRegion = $$v
        },
        expression: "curChartRegion"
      }
    }, [_c('el-radio-button', {
      attrs: {
        "label": "7"
      }
    }, [_vm._v("7天")]), _vm._v(" "), _c('el-radio-button', {
      attrs: {
        "label": "15"
      }
    }, [_vm._v("15天")]), _vm._v(" "), _c('el-radio-button', {
      attrs: {
        "label": "30"
      }
    }, [_vm._v("30天")])], 1)], 1)], 1), _vm._v(" "), _c('echarts', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.chartLoading),
        expression: "chartLoading"
      }],
      attrs: {
        "options": _vm.lineChart
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "table-con"
  }, [(_vm.basicData) ? _c('el-row', {
    staticClass: "row-bg title",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "选择日期",
      "editable": false,
      "clearable": false
    },
    on: {
      "change": _vm.switchTableRegion
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('a', {
    staticClass: "el-button el-button--primary",
    class: _vm.tableData.length && !_vm.tableLoading ? '' : 'is-disabled',
    attrs: {
      "href": ("/report/active/export?city=" + (_vm.exportParams().city) + "&start=" + (_vm.exportParams().startDate) + "&end=" + (_vm.exportParams().endDate)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _c('span', {
    staticClass: "exportText"
  }, [_vm._v("导出表格")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.tableData) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": ""
    }
  }, _vm._l((_vm.incrementKey), function(iKey) {
    return _c('el-table-column', {
      key: iKey.key,
      attrs: {
        "prop": iKey.key,
        "label": iKey.label,
        "label-class-name": iKey.key,
        "width": iKey.width,
        "sortable": "",
        "show-overflow-tooltip": ""
      }
    })
  })) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "oTip forTitle"
  }, [_vm._v("部分数据因为用户未授权地理位置权限，无法获取地理位置，没有显示在本表中，请悉知。")]), _vm._v(" "), _c('p', {
    staticClass: "oTip forType"
  }, [_vm._v("昨日数据和上周日均数据的对比")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("昨日关键数据"), _c('span', {
    staticClass: "oHelp forTitle"
  }, [_vm._v("?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-764cd629","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataCenter/incrementData.vue
// module id = 946
// module chunks = 1